import React, { useEffect, useState, useRef } from 'react';
import { PlusIcon, SendIcon, MicIcon } from 'lucide-react';
interface ChatInputProps {
  onSendMessage: (message: string) => void;
}
export const ChatInput = ({
  onSendMessage
}: ChatInputProps) => {
  const [message, setMessage] = useState('');
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isVoiceMode, setIsVoiceMode] = useState(false);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const autoResizeTextarea = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = `${Math.min(textarea.scrollHeight, 250)}px`;
    }
  };
  useEffect(() => {
    setIsButtonDisabled(message.trim().length === 0);
  }, [message]);
  useEffect(() => {
    autoResizeTextarea();
  }, [message]);
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (!isButtonDisabled) {
        sendMessage();
      }
    }
  };
  const sendMessage = () => {
    if (message.trim()) {
      onSendMessage(message.trim());
      setMessage('');
    }
  };
  return <div className="w-full max-w-[800px] mx-auto flex items-end gap-3" data-id="element-50">
      <div className="flex-grow bg-[#2d2d2d] border border-[#444444] rounded-2xl p-3" data-id="element-51">
        <div className="flex items-start gap-3" data-id="element-52">
          <button className="mt-1.5 text-[#888888] p-2 rounded-lg hover:bg-[#3a3a3a] hover:text-[#e0e0e0] transition-colors" title="Attach file" data-id="element-53">
            <PlusIcon size={20} data-id="element-54" />
          </button>
          <textarea ref={textareaRef} className="flex-grow min-h-[24px] max-h-[250px] overflow-y-auto text-base leading-relaxed py-2 bg-transparent focus:outline-none placeholder:text-[#666666]" placeholder="Ask me anything..." value={message} onChange={e => setMessage(e.target.value)} onKeyDown={handleKeyDown} rows={1} data-id="element-55" />
          <button className={`rounded-full w-10 h-10 flex items-center justify-center mt-1 transition-all ${!isButtonDisabled ? 'bg-[#4a90e2] hover:bg-[#3a7bc2] text-white' : 'bg-[#3a3a3a] text-[#666666] cursor-not-allowed'}`} title="Send message" disabled={isButtonDisabled} onClick={sendMessage} data-id="element-56">
            <SendIcon size={18} data-id="element-57" />
          </button>
        </div>
      </div>

      <button onClick={() => setIsVoiceMode(!isVoiceMode)} className={`rounded-full w-14 h-14 flex items-center justify-center transition-all flex-shrink-0 ${isVoiceMode ? 'bg-[#4a90e2] hover:bg-[#3a7bc2]' : 'bg-[#2d2d2d] hover:bg-[#3a3a3a] border border-[#444444]'}`} title={isVoiceMode ? 'Stop voice input' : 'Start voice input'} data-id="element-58">
        <MicIcon size={22} className={isVoiceMode ? 'text-white' : 'text-[#e0e0e0]'} data-id="element-59" />
      </button>
    </div>;
};